import logoImg from '../assets/logo.png';

export default function Logo({ size = 'md', showText = false }) {
  const heights = { sm: 38, md: 50, lg: 66 };
  const h = heights[size] || 50;
  return (
    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
      <img
        src={logoImg}
        alt="YN Dream Curtains"
        width={h} height={h}
        style={{ width:h, height:h, objectFit:'contain', borderRadius:8, flexShrink:0,
          filter:'drop-shadow(0 2px 8px rgba(139,109,56,0.2))' }}
      />
      {showText && (
        <div>
          <div style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: size==='lg' ? '1rem' : size==='sm' ? '0.72rem' : '0.86rem',
            fontWeight: 800,
            color: 'var(--gold)',
            letterSpacing: '0.12em',
            lineHeight: 1.1,
            textTransform: 'uppercase',
          }}>
            YN Dream Curtains
          </div>
          <div style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '0.46rem',
            letterSpacing: '0.28em',
            color: 'var(--text-dim)',
            textTransform: 'uppercase',
            marginTop: 4,
          }}>
            Excellence and Elegance
          </div>
        </div>
      )}
    </div>
  );
}
